import { render, staticRenderFns } from "./ChapterWelcomeMessage.vue?vue&type=template&id=e0a41a30&scoped=true&"
import script from "./ChapterWelcomeMessage.vue?vue&type=script&lang=js&"
export * from "./ChapterWelcomeMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChapterWelcomeMessage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChapterWelcomeMessage.vue?vue&type=style&index=1&id=e0a41a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a41a30",
  null
  
)

export default component.exports